<template>
  <hm-content title="审单提示">
    <div class="table-panel  flex flex-between ">
      <div class="flex flex-wrap item-center">
        <el-button type="primary" size="small" class="mr10" @click="addNotice"
          >添加审单提示</el-button
        >
      </div>
      <div>        
        <el-select
          size="small"
          clearable
          placeholder="选择状态"
          v-model="searchCondition.enabledState"
          style="width: 150px"
          class="mr10"          
        >
          <el-option
            v-for="item in enabledStateBox"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-select
          size="small"
          clearable
          placeholder="选择提示类型"
          v-model="searchCondition.noticeType"
          style="width: 150px"
          class="mr10"
          @change="noticeTypeChange('searchCondition')"
        >
          <el-option
            v-for="item in noticeTypeBox"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-select
          clearable
          size="small"
          class="mr10"
          filterable
          v-model="searchCondition.noticeRelId"
          placeholder="请选择品牌"
          v-show="searchCondition.noticeType==='brand'"
        >
          <el-option
            :label="v.brandName"
            :value="v.hemiaoBrandId"
            v-for="(v, i) in hemiaoBrandBoxList"
            :key="i"
          ></el-option>
        </el-select>
        <el-select
          size="small"
          clearable
          class="mr10"
          placeholder="请输入并选择商户"
          v-model="searchCondition.noticeRelId"
          filterable
          remote
          :remote-method="remoteMethod"
          v-show="searchCondition.noticeType==='store'"
        >
          <el-option
            :label="item.storeName"
            :value="item.storeCode"
            v-for="(item) in storeBasicList"
            :key="item.storeCode"
          >
          </el-option>
        </el-select>
        <el-select
          clearable
          size="small"
          class="mr10"
          filterable
          v-model="searchCondition.noticeRelId"
          placeholder="请选择供货商"
          v-show="searchCondition.noticeType==='supplier'"
        >
          <el-option
            :label="v.storeName"
            :value="v.storeCode"
            v-for="(v, i) in supplierList"
            :key="i"
          ></el-option>
        </el-select>        
        <el-input
          clearable
          v-model.trim="searchCondition.noticeContent"
          placeholder="请输入提示内容关键词"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
    </div>
    <div class="table">
      <el-table
        stripe
        :data="supplierReceiptList.records"
        style="width: 100%"
        id="table"
        size="small"
        border
      >
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="noticeType"
          label="提示类型"
        >
          <template slot-scope="scope">
            <div v-for="item in noticeTypeBox" :key="item.value">
              <span v-show="scope.row.noticeType===item.value">{{item.name}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="noticeRelName"
          label="关联对象"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="noticeContent"
          label="提示内容"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="enabledState"
          label="状态"
        >
          <template slot-scope="scope">
            <div v-for="item in enabledStateBox" :key="item.value">
              <span :class="item.class" v-show="scope.row.enabledState===item.value">{{item.name}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="updateTime"
          label="最后修改时间"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="updateBy"
          label="最后修改人"
        >
        </el-table-column>
        <el-table-column
          label="操作"
          width="150"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <el-button size="small" type="text" @click="edit(scope.row)"
            >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="supplierReceiptList.total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total,sizes,  prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
    <el-dialog
      :title="mode === 'add' ? '新增审单提示' : '编辑审单提示'"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      @close="resetForm('ruleForm')"
      width="1200px"
      destroy-on-close
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="提示类型" prop="noticeType">
          <el-select
            size="small"
            clearable
            placeholder="选择提示类型"
            v-model="ruleForm.noticeType"
            style="width: 150px"
            class="mr10"
            @change="noticeTypeChange('ruleForm')"
          >
            <el-option
              v-for="item in noticeTypeBox"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="is-required" label="关联对象" prop="noticeRelId" v-show="ruleForm.noticeType">
          <el-select
            clearable
            size="small"
            class="mr10"
            filterable
            v-model="ruleForm.noticeRelId"
            placeholder="请选择品牌"
            v-show="ruleForm.noticeType==='brand'"
          >
            <el-option
              :label="v.brandName"
              :value="v.hemiaoBrandId"
              v-for="(v, i) in hemiaoBrandBoxList"
              :key="i"
            ></el-option>
          </el-select>
          <el-select
            clearable
            size="small"
            class="mr10"
            filterable
            v-model="ruleForm.noticeRelId"
            remote
            :remote-method="remoteMethod"
            placeholder="请输入并选择商户"
            v-show="ruleForm.noticeType==='store'"
          >
            <el-option
              :label="v.storeName"
              :value="v.storeCode"
              v-for="(v, i) in storeBasicList"
              :key="i"
            ></el-option>
          </el-select>
          <el-select
            clearable
            size="small"
            class="mr10"
            filterable
            v-model="ruleForm.noticeRelId"
            placeholder="请选择供货商"
            v-show="ruleForm.noticeType==='supplier'"
          >
            <el-option
              :label="v.storeName"
              :value="v.storeCode"
              v-for="(v, i) in supplierList"
              :key="i"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="关联区域" 
            v-show="ruleForm.noticeType==='supplier'"
        >
          <el-row>
            <el-row><el-input size="small" v-model="areaKeyWords" placeholder="请输入区域" class="mr20" clearable></el-input><el-button size="small" type="primary" @click="handleAreaSearch">查询</el-button></el-row>
          </el-row>
            <hm-base-transfer
              v-if="dialogVisible"
              ref="provinceTransfer"
              leftName="可选区域"
              rightName="已选区域"
              :leftOption="filterArea"
              :leftProps="leftProps"
              :rightProps="leftProps"
              compareKey="code"
            ></hm-base-transfer>
        </el-form-item>
        <el-form-item label="关联连锁"
            v-show="ruleForm.noticeType==='supplier'"
        >
            <div>
              <el-input size="small" v-model="providerKeyWords" class="mr20" clearable placeholder="请输入连锁"></el-input><el-button size="small" @click="queryProviderList" type="primary">查询</el-button>
            </div>
            <hm-base-transfer
              v-if="dialogVisible"
              ref="providerTransfer"
              leftName="可择连锁"
              rightName="已选连锁"
              :leftOption="leftOption2"
              :leftProps="leftProps2"
              :rightProps="leftProps2"
              compareKey="storeCode"
            ></hm-base-transfer>
          </el-form-item>
        <el-form-item label="提示内容" prop="noticeContent">
          <el-input
            style="width: 360px"
            type="textarea"
            v-model="ruleForm.noticeContent"
            placeholder="多行文本，请输入提示内容"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="enabledState">
          <el-switch
            v-model="ruleForm.enabledState"
            active-text="开启"
            inactive-text="关闭"
            active-color="#13ce66"
            active-value="yes"
            inactive-value="no"
          ></el-switch>
        </el-form-item>
        <div class="flex flex-center">
          <el-button type="primary" size="small" @click="submitForm('ruleForm')"
            >提交</el-button
          >
          <el-button size="small" @click="resetForm('ruleForm')"
            >返回</el-button
          >
        </div>
      </el-form>
    </el-dialog>
  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";
import area from "@/utils/area";
import { getCookie, setCookie } from "@/utils/utils";
import HmBaseTransfer from "@/components/HmBaseTransfer";
let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串
export default {
  components: { HmBaseTransfer },
  data() {
    return {
      type: "",
      noticeTypeBox: [
        {
          name: "品牌",
          value: "brand",
        },
        {
          name: "商户",
          value: "store",
        },
        {
          name: "供货商",
          value: "supplier",
        },
      ],
      hemiaoBrandBoxList: [],
      storeList: [],
      supplierList: [],
      enabledStateBox: [
        {
          name: "生效中",
          value: "yes",
          class: "success",
        },
        {
          name: "未生效",
          value: "no",
          class: "gray",
        },
      ],
      mode: "add",
      dialogVisible: false,
      ruleForm: {
        noticeType: "",
        noticeRelId: "",
        noticeContent: "",
        enabledState: "open",
      },
      rules: {
        noticeType: {
          required: true,
          trriger: "blur",
          message: "请选择提示类型",
        },
        noticeRelId: {
          required: true,
          trriger: "blur",
          message: "请选择关联对象",
        },
      },
      searchCondition: {
        enabledState: "",
        noticeType: "",
        noticeRelId: "",
        noticeContent: "",
      },
      currentPage: 1,
      pageSize: 10,
      editRow: {},
      storeBasicList: [],
      allStoreBasicList: [],

      // 省份
      leftProps: [
        {
          name: "省份",
          value: "name",
        },
      ],
      leftOption: [
        { code: "110000", name: "北京市" },
        { code: "120000", name: "天津市" },
        { code: "130000", name: "河北省" },
        { code: "140000", name: "山西省" },
        { code: "150000", name: "内蒙古自治区" },
        { code: "210000", name: "辽宁省" },
        { code: "220000", name: "吉林省" },
        { code: "230000", name: "黑龙江省" },
        { code: "310000", name: "上海市" },
        { code: "320000", name: "江苏省" },
        { code: "330000", name: "浙江省" },
        { code: "340000", name: "安徽省" },
        { code: "350000", name: "福建省" },
        { code: "360000", name: "江西省" },
        { code: "370000", name: "山东省" },
        { code: "410000", name: "河南省" },
        { code: "420000", name: "湖北省" },
        { code: "430000", name: "湖南省" },
        { code: "440000", name: "广东省" },
        { code: "450000", name: "广西壮族自治区" },
        { code: "460000", name: "海南省" },
        { code: "500000", name: "重庆市" },
        { code: "510000", name: "四川省" },
        { code: "520000", name: "贵州省" },
        { code: "530000", name: "云南省" },
        { code: "540000", name: "西藏自治区" },
        { code: "610000", name: "陕西省" },
        { code: "620000", name: "甘肃省" },
        { code: "630000", name: "青海省" },
        { code: "640000", name: "宁夏回族自治区" },
        { code: "650000", name: "新疆维吾尔自治区" },
      ],
      leftProps2: [
        {
          name: "供货商名称",
          value: "storeName",
        },
      ],
      leftOption2: [],
      filterArea: [],
      providerKeyWords: "",
      areaKeyWords: "",
    };
  },
  computed: mapGetters(["supplierReceiptList"]),
  watch: {},
  created() {},
  mounted() {
    this.filterArea = JSON.parse(JSON.stringify(this.leftOption));
    this.queryBrandList();
    this.queryStoreBasicList();
    this.findStorePageByType("supplier");
    this.queryList();
    // this.queryTenantBasicInfoList();
    // this.queryStoreList()
  },
  methods: {
    async queryStoreList() {
      let params = {
        pageSize: 999,
        pageNo: 1,
        queryRewardFlag: "include",
        queryRewardNumStat: "include",
        queryShopStat: "include",
        queryTemplateStat: "include",
        queryRiskeStat: "include",
        storeName: this.providerKeyWords,
        applyDate: null,
        createTimeStart: "",
        createTimeEnd: "",
      };

      const { code, result } = await this.$store.dispatch(
        "queryStoreBasicList",
        params
      );
      if (code === "0") {
        console.log("---result---", result);
      }
    },
    handleAreaSearch() {
      this.filterArea = this.leftOption.filter((item) =>
        item.name.includes(this.areaKeyWords)
      );
    },
    async queryTenantBasicInfoList() {
      const { code, result } = await this.$store.dispatch(
        "tenantBasicInfoList"
      );

      if (code === "0") {
        this.tenantBasicInfoList = result.records;
        this.queryProviderList();
      }
    },
    queryProviderList() {
      if(this.providerKeyWords) {
        this.leftOption2 = this.allStoreBasicList.filter(item => item.storeName.includes(this.providerKeyWords))
      } else {
        this.leftOption2 = this.allStoreBasicList.slice(0, 200)
      }
    },
    // async queryProviderList() {
    //   let params = {
    //     pageSize: 9999,
    //     pageNo: 1,
    //     keyWords: this.providerKeyWords,
    //     createTimeEnd: "",
    //     createTimeStart: "",
    //   };
    //   if (!this.providerKeyWords) {
    //     delete params.keyWords;
    //   }
    //   console.log(params);
    //   const { code, result } = await this.$store.dispatch(
    //     "querySupplierBasicList",
    //     params
    //   );
    //   if (code === "0") {
    //     result.records.forEach((v) => {
    //       this.tenantBasicInfoList.forEach((o) => {
    //         if (o.tenantId === v.tenantId) {
    //           v.tenantName = o.tenantCompanyName;
    //         }
    //       });
    //     });
    //     this.leftOption2 = result.records;
    //     console.log("---result.records---", result.records);
    //     this.total = result.total;
    //   }
    // },
    async queryBrandList() {
      const { result } = await this.$store.dispatch("queryHemiaoBrandComboBox");
      this.hemiaoBrandBoxList = result;
    },
    async findStorePageByType(type) {
      let params = {
        storeType: type,
        pageSize: "99999",
      };
      const { result } = await this.$store.dispatch(
        "findStorePageByType",
        params
      );
      if (type === "supplier") {
        this.supplierList = result.records;
        console.log("this.supplierList:", this.supplierList);
      }
    },
    noticeTypeChange(type) {
      console.log("type:", type);
      if (type === "searchCondition") {
        this.searchCondition.noticeRelId = "";
      }
      if (type === "ruleForm") {
        this.ruleForm.noticeRelId = "";
      }
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    queryList() {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      // this.setParamsCookie();
      return this.$store.dispatch("querySupplierReceiptList", params);
    },
    // setParamsCookie() {
    //   setCookie({
    //     key: "redpackageMerchantListParamsNew",
    //     type: "session",
    //     data: Object.assign({}, this.searchCondition, {
    //       pageSize: this.pageSize,
    //       currentPage: this.currentPage
    //     })
    //   });
    // },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    async edit(row) {
      const { result } = await this.$store.dispatch(
        "queryByIdSupplierReceipt",
        {
          noticeType: row.noticeType,
          noticeRelId: row.noticeRelId,
          id: row.id,
        }
      );
      if (result) {
        this.ruleForm = result;
        this.mode = "edit";
        this.dialogVisible = true;
        const { applyShopValueList, applyProvinceValueList } = result;
        // console.log("--result.applyShopValueList---", applyShopValueList);
        // console.log(
        //   "---applyProvinceValueList---applyProvinceValueList---",
        //   applyProvinceValueList
        // );
        // console.log('--this.leftOption--', this.leftOption);
        // const filterProvince = this.leftOption.filter(item => applyProvinceValueList.indexOf(item.code) > -1)
        // const filterShop = this.allStoreBasicList.filter(item => applyShopValueList.indexOf(item.storeCode) > -1)
        // console.log(filterProvince.length, applyProvinceValueList.length);
        // console.log(filterShop.length, applyShopValueList.length);
        if (applyShopValueList && applyShopValueList.length) {
          const applyShopValueList2 = this.allStoreBasicList.filter(
            (item) => applyShopValueList.indexOf(item.storeCode) > -1
          );
          console.log("--applyShopValueList2--", applyShopValueList2);
          this.$nextTick(() => {
             applyShopValueList2.forEach(v => {
            v.id = v.id || Math.random().toString(36).substring(2, 6);
        });
            this.$refs.providerTransfer.rightData = applyShopValueList2;
            this.$refs.providerTransfer.rightChecked = applyShopValueList2;
            this.$refs.providerTransfer.rightCheckAll = true;
          });
        }
        if (applyProvinceValueList && applyProvinceValueList.length) {
          const applyProvinceValueList2 = this.leftOption.filter(
            (item) => applyProvinceValueList.indexOf(item.code) > -1
          );
          console.log("--applyProvinceValueList2--", applyProvinceValueList2);
          this.$nextTick(() => {
              applyProvinceValueList2.forEach(v => {
            v.id = v.id || Math.random().toString(36).substring(2, 6);
        });
            this.$refs.provinceTransfer.rightData = applyProvinceValueList2;
            this.$refs.provinceTransfer.rightChecked = applyProvinceValueList2;
            this.$refs.providerTransfer.rightCheckAll = true;
          });
        }
        // this.$forceUpdate();
      }
      console.log("this.ruleForm:", this.ruleForm);
    },
    addNotice() {
      this.mode = "add";
      this.dialogVisible = true;
    },
    async submitForm(formName) {
      const valid = await this.$refs[formName].validate();
      if (valid) {
        let params = JSON.parse(JSON.stringify(this.ruleForm));
        let name =
          this.mode === "add" ? "addSupplierReceipt" : "editSupplierReceipt";
        console.log("params:", params);

        if (this.ruleForm.noticeType === "supplier") {
          const applyProvinceValueList = this.$refs.provinceTransfer.rightData;
          const applyShopValueList = this.$refs.providerTransfer.rightData;
          console.log(applyProvinceValueList, applyShopValueList);
          params.applyProvinceValueList = applyProvinceValueList.map(
            (item) => item.code
          );
          params.applyShopValueList = applyShopValueList.map(
            (item) => item.storeCode
          );
        }
        this.$store.dispatch(name, params).then((res) => {
          if (res.code === "0") {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.currentPage = 1;
            this.$refs[formName].resetFields();
            this.queryList();
            this.dialogVisible = false;
            // location.reload();
          }
        });
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();

      this.ruleForm = {
        noticeType: "",
        noticeRelId: "",
        noticeContent: "",
        enabledState: "open",
      };
      this.$refs.provinceTransfer.rightData = [];
      this.$refs.providerTransfer.rightData = [];
      this.dialogVisible = false;
    },
    remoteMethod(query) {
      console.log("query:", query);
      if (query !== "") {
        this.storeBasicList = this.allStoreBasicList.filter(
          (v) => v.storeName.indexOf(query) > -1
        );
      } else {
        this.storeBasicList = [];
      }
    },
    async queryStoreBasicList() {
      const { result } = await this.$store.dispatch(
        "queryStoreBasicListComboBox"
      );
      console.log('---allStoreBasicList---', result);
      this.allStoreBasicList = result || [];
      this.leftOption2 = result.slice(0, 200);
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
